/**
 * @file index.js
 * @description RFQ Module Navigation Wrapper
 * Provides navigation links between:
 * 1. RFQ Listing - /rfq-listing
 * 2. RFQ Approval Listing - /rfq-approval-listing
 */

import React, { useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { Nav, NavItem, NavLink } from "reactstrap";
import classnames from 'classnames';
import RfqListing from "./RfqListing";
import { RFQ_LISTING, RFQ_APPROVAL_LISTING } from "../../config/constants";
import { initial } from "lodash";
import { getConfigurationKey } from "../../helper";

function RfqTabs(props) {
    const history = useHistory();
    const location = useLocation();

    // Determine which tab is active based on current route
    const isApprovalTab = location.pathname === RFQ_APPROVAL_LISTING;

    /**
     * Navigate to RFQ Listing
     */
    const navigateToListing = () => {
        history.push(RFQ_LISTING);
    };

    /**
     * Navigate to RFQ Approval Listing
     */
    const navigateToApproval = () => {
        history.push(RFQ_APPROVAL_LISTING);
    };

    return (
        <>
            <div className="user-page container-fluid costing-main-container">
                <div>
                    {/* Navigation Links */}
                    <Nav tabs className="subtabs mt-0 mb-3">
                        <NavItem>
                            <NavLink
                                className={classnames({ active: !isApprovalTab })}
                                onClick={navigateToListing}
                                style={{ cursor: 'pointer' }}
                            >
                                RFQ Listing
                            </NavLink>
                        </NavItem>
                      {getConfigurationKey().IsRFQApprovalAppliedConfigure && (
                        <NavItem>
                            <NavLink
                                className={classnames({ active: isApprovalTab })}
                                onClick={navigateToApproval}
                                style={{ cursor: 'pointer' }}
                            >
                                Approval Status
                            </NavLink>
                        </NavItem>
                      )}
                    </Nav>

                    {/* Render RfqListing component based on route */}
                    <RfqListing
                        {...props}
                        isApprovalTab={isApprovalTab}
                    />
                </div>
            </div>
        </>
    );
}

export default RfqTabs;
